import gql from 'graphql-tag';

const KEY_CLASSROOM_ENGAGEMENT_QUERY = gql`
  query getClassroomEngagementReport(
    $where: KeyClassroomEngagementReportWhereInput!
    $dateRange: DateRangeInput!
  ) {
    keyClassroomEngagementReport(where: $where, dateRange: $dateRange) {
      assessmentAccelerator {
        averageAttemptCount
        averageFirstAttemptCount
        averageSecondsSpent
        activityTypes {
          activityType {
            id
            name
          }
          modules {
            modules {
              name
              id
            }
            averageAttemptCount
            averageSecondsSpent
          }
        }
        modules {
          modules {
            name
            id
          }
          averageSecondsSpent
          averageAttemptCount
          averageFirstAttemptCount
          activityTypes {
            activityType {
              id
              name
            }
            averageSecondsSpent
            totalCompletedCount
            averageAttemptCount
            totalFirstAttemptCount
          }
        }
      }
      students {
        student {
          id
          firstName
          lastName
          gradeLevel
        }
        productCurriculumCode
        lastLoginDate
        curriculumWeek
        curriculumProgressPercentage
        totalActivitiesCompletedCount
        averageWeeklyMinutesSpent
        spotChecks {
          totalCompletedCount
          dateLastCompleted
          averageWpm
          averageAccuracy
        }
        scheduledActivities {
          assessmentCompletedCount
          assessmentSkippedCount
          assessmentAverageWpm
          assessmentAverageAccuracy
        }
        teacherCreatedActivities {
          totalCompletedCount
          averageWpm
          averageAccuracy
        }
        enrichmentActivities {
          hearItTypeItCompletedCount
          myChoiceKeyboardingCompletedCount
        }
        assessmentAccelerator {
          averageSecondsSpent
          totalCompletedCount
          averageAttemptCount
          totalFirstAttemptCount
          modules {
            modules {
              name
              id
            }
            averageSecondsSpent
            totalCompletedCount
            averageAttemptCount
            totalFirstAttemptCount
            assignmentStatus
          }
        }
      }
    }
  }
`;

export default KEY_CLASSROOM_ENGAGEMENT_QUERY;
